















import { Component, Vue } from 'vue-property-decorator';
import Notifications from '@/components/Notifications.vue'
import Navigation from '@/components/Navigation.vue';
import Version from '@/components/Version.vue';
import Modal from '@/components/Modal.vue';
import { StoreActions } from './store';

@Component({
  components: {
    Notifications,
    Navigation,
    Version,
    Modal,
  }
})
export default class DoorbraakApp extends Vue {
  created() {
    this.$store.dispatch(StoreActions.Auth)
  }

  get showHeader(): boolean {
    return this.$route.path.indexOf('register') === -1;
  }
}

